<template>
  <v-layout row wrap class="white border-radius-standard px-0 py-2">
    <slot name="title">
      <v-flex xs12>
        <div class="title-icon">
          <span
            class="botter-mask-group-44-icon white--text text-lg-2 icon-holder primary"
          />
          <span class="title-content">Interactive Template Message</span>
        </div>
      </v-flex>
    </slot>
    <v-flex v-if="loader.template" xs12 class="mt-1" style="display: flex">
      <v-progress-circular
        :rotate="360"
        :size="120"
        :width="15"
        indeterminate
        color="primary"
        style="margin: auto"
        >Loading Template</v-progress-circular
      >
    </v-flex>

    <v-flex v-if="!loader.template" xs12 class="mt-1">
      <h4 class="template-subtitle">Header (Optional)</h4>
      <label class="grey--text">Choose Media Type</label>
    </v-flex>
    <v-flex v-if="!loader.template" xs12 class="px-0">
      <v-radio-group
        v-model="input.header"
        row
        wrap
        class="headers-wrapper"
        :disabled="disabled"
      >
        <v-radio
          v-for="(head, h) in headerOptions"
          :key="h"
          :value="head.value"
          :disabled="disabled"
          class="header-option"
          color="green lighten-1"
        >
          <v-layout
            slot="label"
            row
            wrap
            class="header-content"
            align-center
            justify-center
          >
            <v-flex xs12 class="text-center py-0 my-0">
              <span
                :class="[
                  { 'primary--text': !disabled },
                  { 'dimmed-primary-text': disabled },
                  'header-icon',
                  `botter-${head.icon}-icon`,
                ]"
              />
            </v-flex>
            <v-flex
              xs12
              :class="[
                'py-0 my-0',
                { 'primary--text': !disabled },
                { 'dimmed-primary-text': disabled },
              ]"
            >
              <p class="text-center my-0 py-0">{{ head.text }}</p>
            </v-flex>
          </v-layout>
        </v-radio>
      </v-radio-group>
    </v-flex>
    <v-flex
      v-if="
        input.header && input.header === 'TEXT' && !loader.template && !showOnly
      "
      class="animated fadeIn"
      xs12
    >
      <label class="grey--text">Title</label>
      <v-text-field
        v-model="input.headerTitle"
        :disabled="disabled"
        placeholder="Header"
        class="field-width"
        outline
        :counter="60"
        :error-messages="inputHeaderTitleErrors"
        @blur="$v.input.headerTitle.$touch()"
      />
    </v-flex>

    <v-flex
      v-if="
        input.header && input.header !== 'TEXT' && !loader.template && !showOnly
      "
      class="animated fadeIn"
      xs12
    >
      <label class="grey--text">Header Sample</label>

      <image-input
        v-if="!disabled"
        :types="handleHeaderSampleAttachmentType"
        maxFiles="1"
        :maxFileSize="handleHeaderSampleAttachmentSize"
        :url="input.headerSampleUrl"
        icon="botter-logo-icon"
        class="field-width"
        :key="input.header"
        @onUploadComplete="updateHeaderSampleUrl"
        @onFileRemove="input.headerSampleUrl = ''"
      />

      <h4 v-if="!disabled">OR</h4>
      <label v-if="!disabled">Insert file link (Public URL)</label>
      <v-text-field
        v-model="input.headerSampleUrl"
        :disabled="disabled"
        placeholder="Header Sample Url"
        class="field-width mt-2"
        outline
        :error-messages="inputHeaderSampleUrlErrors"
        @blur="$v.input.headerSampleUrl.$touch()"
      />
    </v-flex>
    <slot name="header-append" />
    <!-- body starts -->
    <v-flex
      v-if="!loader.template && !showOnly"
      xs12
      class="mt-0 animated fadeIn"
    >
      <h4 class="template-subtitle">Body</h4>
      <label class="grey--text"
        >Type text of your message in language you’ve selected</label
      >
    </v-flex>
    <v-flex
      v-if="!loader.template && !showOnly"
      xs12
      class="pb-0 mb-0 animated fadeIn"
    >
      <v-textarea
        v-model="input.body"
        :disabled="disabled"
        placeholder="Type Your message here.."
        class="field-width"
        :counter="1024"
        outline
        :error-messages="inputBodyErrors"
        @blur="$v.input.body.$touch()"
      />
    </v-flex>

    <div v-for="(sample, index) in bodySamples[0]" :key="index">
      <v-flex xs12 class="mt-0 animated fadeIn" v-if="!disabled">
        <h4 class="template-subtitle">Body Param #{{ index + 1 }} Sample</h4>
        <label class="grey--text"
          >Add an example for paramter {{ index + 1 }}</label
        >
      </v-flex>
      <v-flex v-if="!loader.template && !showOnly" xs12>
        <v-text-field
          v-model="bodySamples[0][index]"
          placeholder="Example"
          class="field-width"
          :disabled="disabled"
          outline
        />
      </v-flex>
    </div>

    <!-- body ends -->
    <!-- footer starts -->
    <v-flex
      v-if="!loader.template && !showOnly"
      xs12
      class="mt-0 animated fadeIn"
    >
      <h4 class="template-subtitle">Footer (Optional)</h4>
      <label class="grey--text"
        >Add a-short line of text to bottom of your message</label
      >
    </v-flex>
    <v-flex v-if="!loader.template && !showOnly" xs12>
      <v-text-field
        v-model="input.footer"
        :disabled="disabled"
        placeholder="Footer"
        class="field-width"
        :counter="60"
        outline
        :error-messages="inputFooterErrors"
        @blur="$v.input.footer.$touch()"
      />
    </v-flex>
    <!-- footer ends -->
    <!-- buttons starts -->
    <v-flex
      v-if="!loader.template && !showOnly"
      xs12
      class="mt-0 animated fadeIn"
    >
      <h4 class="template-subtitle">Buttons (Optional)</h4>
    </v-flex>
    <v-flex
      v-if="!loader.template && !showOnly"
      xs12
      class="px-0 animated fadeIn"
    >
      <v-radio-group
        v-model="buttonsType"
        row
        wrap
        class="buttons-radio-gp px-0 field-width"
        :disabled="disabled"
      >
        <v-radio
          v-for="(head, h) in buttonsOptions"
          :key="h"
          :value="head.value"
          :disabled="disabled"
          :class="['button-option', { disabled: disabled }]"
          color="green lighten-1"
          @click="buttonsType = head.value"
        >
          <div slot="label" :class="{ 'primary--text': !disabled }">
            {{ head.text }}
          </div>
        </v-radio>
      </v-radio-group>
    </v-flex>
    <v-flex v-if="!loader.template && !showOnly" xs12 class="animated fadeIn">
      <label class="grey--text field-width"
        >Create up to 2 buttons that let customer respond to your message Or
        take actions</label
      >
    </v-flex>
    <v-flex v-if="!loader.template && !showOnly" xs12 class="animated fadeIn">
      <template-message-buttons
        v-model="buttons"
        :type="buttonsType"
        :disabled="disabled"
      />
    </v-flex>
    <!-- buttons ends -->
  </v-layout>
</template>

<script>
import imageInput from "@/components/block-build/blocks/block-cards/common-inner-blocks/image-uploader-dropzone";
import { validationMixin } from "vuelidate";
import { helpers, maxLength, required, url } from "vuelidate/lib/validators";
import TemplateMessageButtons from "./TemplateMessageButtons";

const requiredIfHeaderText = helpers.withParams(
  { type: "requiredIfHeaderText" },
  (value, vm) => {
    if (vm.header === "TEXT") {
      return !!value;
    }
    return true;
  }
);

const requiredIfHeaderNotText = helpers.withParams(
  { type: "requiredIfHeaderNotText" },
  (value, vm) => {
    if (vm.header && vm.header !== "TEXT") {
      return !!value;
    }
    return true;
  }
);

export default {
  name: "TemplateMessageEditor",
  mixins: [validationMixin],
  components: {
    TemplateMessageButtons,
    imageInput,
  },
  validations: {
    input: {
      headerTitle: {
        required: requiredIfHeaderText,
        maxLength: maxLength(60),
      },
      headerSampleUrl: {
        required: requiredIfHeaderNotText,
        url,
      },
      footer: { maxLength: maxLength(60) },
      body: { required, maxLength: maxLength(1024) },
    },
  },
  props: {
    templateId: {
      type: String,
      required: true,
    },
    disable: {
      type: Boolean,
      default: false,
    },
    showOnly: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      templateData: null,
      buttons: [],
      headerOptions: [
        { value: null, icon: "none", text: "None" },
        { value: "TEXT", icon: "font", text: "Text" },
        { value: "IMAGE", icon: "image1", text: "Image" },
        { value: "DOCUMENT", icon: "doc", text: "Document" },
        { value: "VIDEO", icon: "youtube", text: "Video" },
      ],
      buttonsOptions: [
        { value: null, text: "None" },
        { value: "quickReply", text: "Quick Reply" },
        { value: "actions", text: "Actions" },
      ],
      input: {
        header: null,
        headerTitle: "",
        headerSampleUrl: "",
        body: "",
        footer: "",
        buttons: [],
      },
      bodySamples: [],
      buttonsType: null,
      loader: {
        template: false,
      },
    };
  },
  computed: {
    templateMessageStatus() {
      if (this.templateData) {
        let status = Array.isArray(this.templateData.status)
          ? this.templateData.status[0].value.toLowerCase()
          : this.templateData.status.toLowerCase();

        return status;
      }

      return null;
    },
    disabled() {
      return (
        this.templateMessageStatus === "approved" ||
        this.templateMessageStatus === "pending" ||
        this.disable
      );
    },
    componentsValue() {
      let temp = {};
      const result = [];

      if (this.buttons && this.buttons.length) {
        result.push({
          type: "BUTTONS",
          buttons: this.buttons,
        });
      }

      if (this.input.header) {
        temp = {
          type: "HEADER",
          format: this.input.header,
        };
        if (temp.format === "TEXT") {
          temp.text = this.input.headerTitle;
        } else {
          temp.example = {};
          temp.example.header_handle = [this.input.headerSampleUrl];
        }
        result.push(temp);
      }

      result.push({
        type: "BODY",
        text: this.input.body,
        ...(this.bodySamples.length && {
          example: {
            body_text: this.bodySamples,
          },
        }),
      });

      if (this.input.footer && this.input.footer.length) {
        result.push({
          type: "FOOTER",
          text: this.input.footer,
        });
      }

      return result;
    },
    handleHeaderSampleAttachmentType() {
      if (this.input.header === "DOCUMENT") {
        return "application/pdf, application/docx, application/doc";
      } else if (this.input.header === "VIDEO") {
        return "video/mp4";
      } else {
        return "image/png, image/jpeg, image/jpg";
      }
    },
    handleHeaderSampleAttachmentSize() {
      if (this.input.header === "DOCUMENT") {
        return 100;
      } else if (this.input.header === "VIDEO") {
        return 15;
      } else {
        return 5;
      }
    },
    inputHeaderTitleErrors() {
      const errors = [];
      if (!this.$v.input.headerTitle.$dirty) return errors;
      if (!this.$v.input.headerTitle.required)
        errors.push("Header title is required when header type is Text.");
      if (!this.$v.input.headerTitle.maxLength)
        errors.push("Header title must be less than 60 characters.");
      return errors;
    },
    inputHeaderSampleUrlErrors() {
      const errors = [];
      if (!this.$v.input.headerSampleUrl.$dirty) return errors;
      if (!this.$v.input.headerSampleUrl.required)
        errors.push("Header sample URL is required for this header type.");
      return errors;
    },
    inputBodyErrors() {
      const errors = [];
      if (!this.$v.input.body.$dirty) return errors;
      if (!this.$v.input.body.required) errors.push("Body is required.");
      if (!this.$v.input.body.maxLength)
        errors.push("Body must be less than 1024 characters.");
      return errors;
    },

    inputFooterErrors() {
      const errors = [];
      if (!this.$v.input.footer.$dirty) return errors;
      if (!this.$v.input.footer.maxLength)
        errors.push("Footer must be less than 60 characters.");
      return errors;
    },
    isFormValid() {
      return !this.$v.$invalid;
    },
  },
  watch: {
    "input.body": {
      deep: true,
      immediate: true,
      handler(val) {
        const regex = /{{\d+}}/g;
        const matches = val.match(regex);

        if (matches) {
          // Convert matches to a Set (removes duplicates), then back to array
          const uniqueMatches = Array.from(new Set(matches));
          const max = uniqueMatches.length;

          // If bodySamples is empty, initialize with a nested empty array
          if (!this.bodySamples.length) {
            this.bodySamples = [[]];
          }

          // Adjust the length of this.bodySamples[0] based on number of unique matches
          if (max > 0) {
            if (this.bodySamples[0].length < max) {
              for (let i = this.bodySamples[0].length; i < max; i++) {
                this.bodySamples[0].push("");
              }
            } else if (this.bodySamples[0].length > max) {
              for (let i = this.bodySamples[0].length; i > max; i--) {
                this.bodySamples[0].pop();
              }
            }
          }
        } else {
          this.bodySamples = [];
        }
      },
    },
    buttons: {
      deep: true,
      immediate: true,
      handler(val) {
        this.input.buttons = val;
      },
    },
    componentsValue: {
      deep: true,
      immediate: true,
      handler(val) {
        this.$emit("input", val);
      },
    },
    templateData: {
      deep: true,
      immediate: true,
      handler(val) {
        this.$emit("info", val);
      },
    },
    templateId: {
      immediate: true,
      async handler(val) {
        if (val) {
          await this.getTemplateData();
        }
      },
    },
  },
  async mounted() {
    await this.getTemplateData();
  },
  methods: {
    updateHeaderSampleUrl(e) {
      this.input.headerSampleUrl = e[0].url;
    },
    async getTemplateData() {
      try {
        this.loader.template = true;
        const response = await this.$http_session_manager.get(
          `/template-message/${this.templateId}`
        );

        this.templateData = response.data;
        if (response.data.components) {
          const components = response.data.components;
          // handle header
          let header = components.filter((c) => c.type === "HEADER");
          if (header && header.length) {
            header = header[0];
            this.input.header = header.format;
            if (header.format === "TEXT") {
              this.input.headerTitle = header.text;
            } else {
              this.input.headerSampleUrl =
                header.example && header.example.header_handle[0];
            }
          }
          // handle body
          let body = components.filter((c) => c.type === "BODY");
          if (body && body.length) {
            body = body[0];
            this.input.body = body.text;

            if (body.example && body.example.body_text.length) {
              this.bodySamples = body.example.body_text;
            }
          }
          // handle footer
          let footer = components.filter((c) => c.type === "FOOTER");
          if (footer && footer.length) {
            footer = footer[0];
            this.input.footer = footer.text;
          }
          // handle buttons
          let buttons = components.filter((c) => c.type === "BUTTONS");
          if (buttons && buttons.length) {
            buttons = buttons[0];
            if (buttons.buttons.length) {
              this.buttonsType =
                buttons.buttons[0].type === "QUICK_REPLY"
                  ? "quickReply"
                  : "actions";
            }
            // this.input.buttons = buttons.buttons;
            this.buttons = buttons.buttons;
          }
        }
        this.loader.template = false;
      } catch (e) {
        this.loader.template = false;
        throw e;
      }
    },
    async save() {
      this.$v.$touch();
      if (this.isFormValid) {
        await this.$http_session_manager.put(
          `/template-message/${this.$route.params.id}/save`,
          {
            components: this.componentsValue,
          }
        );
      } else {
        throw "Please fix validation errors before saving.";
      }
    },
    async submit() {
      this.$v.$touch();
      if (this.isFormValid) {
        const response = await this.$http_session_manager.put(
          `/template-message/${this.$route.params.id}/submit`,
          {
            components: this.componentsValue,
          }
        );

        this.templateData = response.data;
      } else {
        throw "Please fix validation errors before submitting.";
      }
    },
  },
};
</script>

<style lang="scss">
.dimmed-primary-text {
  color: rgba(55, 47, 172, 0.3);
}

.header-option {
  width: 100px;
  height: 100px;
  padding: 3px;
  border-radius: 8px;
  border: 1px dashed #ccc;
  background-color: #f4f5f9;
  display: block;
  margin-bottom: 16px;
}
.header-content {
  width: 100px;
  margin-left: -3px;
}
.title-icon {
  .icon-holder {
    border-radius: 8px;
    padding: 3px;
  }
  .title-content {
    padding-left: 5px;
    vertical-align: super;
    font-size: 16px;
  }
}
.template-subtitle {
  font-size: 16px;
  font-weight: bold;
  padding-top: 4px;
}
.button-option {
  border: 1px solid #372fac;
  border-radius: 8px;
  padding: 10px 5px;
  width: 30%;
  justify-content: center;
  cursor: pointer;
  margin-left: 0px;
  margin-right: 4px;
  &.disabled {
    border-color: #ccc;
  }
}
.buttons-radio-gp {
  .v-input__control {
    width: 100%;
  }
}
.field-width {
  width: 410px;
}
.template-msg-editor {
  border-right: 2px dashed #f4f5f9;
}
.template-title {
  font-weight: bold;
  font-size: 22px;
}
.header-icon {
  font-size: 24px;
}
</style>
